import { AfterViewInit, Directive, ElementRef, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { throttleTime } from 'rxjs/operators';
import { runtimeEnv } from 'src/environments/env-loader';
import { environment } from 'src/environments/environment';

@Directive({
  selector: '[appThrottledDirective]'
})
export class ThrottledDirective implements AfterViewInit, OnDestroy {
  readonly TO_MILISECONDS: number = 1000;
  readonly TIME_TO_REFRESH: number = runtimeEnv.THROTTLEDREFRESHBALANCE * this.TO_MILISECONDS;

  @Input('appThrottled') eventName: string;
  @Input('appThrottledDuration') duration = this.TIME_TO_REFRESH;
  @Output('appThrottledEvent') event = new EventEmitter<Event>();

  private eventSubject = new Subject<Event>();
  private eventSub: Subscription;

  constructor(private elementRef: ElementRef) {
    this.eventSub = this.eventSubject.pipe(throttleTime(this.duration)).subscribe((event) => this.event.emit(event));
  }

  ngAfterViewInit() {
    if (!this.eventName) {
      return;
    }
    this.elementRef.nativeElement.addEventListener(this.eventName, (event) => this.eventSubject.next(event));
  }

  ngOnDestroy() {
    this.eventSub.unsubscribe();
  }
}
